import React, { useEffect } from "react";
import PageHeader from "../../shared-components/PageHeader";
import Container from "../../shared-components/Container";
import CheckAssignmentTable from "./CheckAssignmentTable";
import LoadingSpinner from "../../shared-components/LoadingSpinner";
import { useAssignmentHooks } from "./AssignmentHooks";
import { LoadedSince } from "../../shared-components/LoadedSince";
import { AssignmentDomain, AssignmentModel } from "./models";
import Button from "../../shared-components/Button";
import { useSyncBlueprintTask } from "../../api/BlueprintsApi";
import ErrorMessageContainer from "../../shared-components/ErrorMessageContainer";

type Props = {};

const CheckAssignment = (props: Props) => {
  const { isLoading, headers, data, loadActorInfo, updatedAt } =
    useAssignmentHooks("blueprint");

  const {
    isLoading: isSyncLoading,
    isError: isSyncError,
    mutate: syncBlueprintTaks,
    data: syncData,
  } = useSyncBlueprintTask();

  useEffect(() => {
    if (syncData) {
      loadActorInfo();
    }
  }, [loadActorInfo, syncData]);

  return (
    <div>
      <PageHeader title={"Check Type Assignment"}></PageHeader>
      <Container>
        <h1 className="text-3xl font-bold pb-6">Assignments</h1>
        <div className="flex justify-between items-center pb-4">
          {!isSyncLoading && (
            <Button
              text={"Sync Check Types"}
              onClick={() => syncBlueprintTaks()}
            />
          )}
          {isSyncLoading && <LoadingSpinner />}
          <LoadedSince
            reportData={{ timestamp: updatedAt }}
            onClear={() => {
              loadActorInfo();
            }}
            className="mb-4"
          />
        </div>
        {isSyncError && (
          <ErrorMessageContainer
            message={"Error syncing check type information"}
          />
        )}
        {isLoading && <LoadingSpinner />}
        {!isLoading && (
          <CheckAssignmentTable
            headers={headers}
            data={data}
            domain={AssignmentDomain.blueprint}
            model={AssignmentModel.Blueprints}
          />
        )}
      </Container>
    </div>
  );
};

export default CheckAssignment;
